module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clifford A. Pickover\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Clifford A. Pickover, a research staff member at IBM’s T. J. Watson Research Center, is an authority on the interface of science, art, mathematics, computing, and the visual modeling of data. He is the author of such highly regarded books as "), _c('I', [_vm._v("Black Holes: A Traveler’s Guide")]), _vm._v(", "), _c('I', [_vm._v("The Alien IQ Test")]), _vm._v(", and "), _c('I', [_vm._v("Chaos in Wonderland: Visual Adventures in a Fractal World")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jII6U9/tc-custom/9781454933007.jpg?1737330896088",
      "alt": "This image is the cover for the book Science Book, Union Square & Co. Milestones"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Science Book, Union Square & Co. Milestones\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From astronomy to psychology, this comprehensive and fully illustrated volume presents the most groundbreaking milestones in the history of science. ")]), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v("Science author Cliff Pickover continues his award–winning series—which includes "), _c('i', [_vm._v("The Math Book")]), _vm._v(", "), _c('i', [_vm._v("The Physics Book, ")]), _vm._v("and"), _c('i', [_vm._v(" The Medical Book")]), _vm._v("—by gathering the most important thinkers and ideas in the history of science into one gorgeously illustrated volume."), _c('br'), _c('br'), _vm._v("This unique omnibus edition includes 250 thoughtfully selected entries from many of the science-based books in the Sterling Milestones series, including math, physics, medicine, biology, chemistry, engineering, psychology, and space. With a new introduction by Pickover explaining how this impressive collection was curated, "), _c('i', [_vm._v("The Science Book")]), _vm._v(" showcases humanity’s greatest achievements and provides readers with a sense of wonder at the diversity of scientific discovery.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0